import { SafeParseReturnType, Schema, ZodIssue } from 'zod';

export const logError = (err: ZodIssue, name: string) => {
  try {
    console.error(
      `ZOD Error in ${name}: ${err.code} / ${err.path.join('.')} / ${
        err.message
      }`
    );
  } catch (e) {
    console.error(`logError mistake in ${name}`, e, err);
  }
};

type Options = {
  name: string | undefined;
};

export const validateScheme = <T1>(
  schema: Schema,
  data: T1,
  options?: Options
): SafeParseReturnType<T1, T1> => {
  const { name = '' } = options || {};

  let response = schema.safeParse(data);

  response = schema.safeParse(data);

  if (!response.success) {
    response?.error?.errors?.forEach((e) => logError(e, name));
  }

  return response;
};
